:host {
  display: flex;
  flex-flow: column nowrap;

  .uic-radio-group__label {
    @include font(normal);
    padding: 2px 8px;
  }
}
